import React, { Component } from 'react'

import { Col, Row, ControlLabel } from "react-bootstrap";

import { connect } from 'react-redux';

import ProjectSelect from 'components/ProjectSelect/ProjectSelect';
import ProductSelectMap from 'components/ProductSelectMap/ProductSelectMap';
import ProductSelectedInfo from 'components/ProductSelectedInfo/ProductSelectedInfo';
import Loader from "components/elements/loader/Loader";

import {
    updateCommercialProject,
    updateParentProject,
    updateProduct,
    cleanState
} from 'reducers/projectsview/projectsviewActions';
import { fetchCommercialProjects, fetchParentProjects } from 'reducers/project/projectActions';

class Projects extends Component {

    constructor(props) {
        super(props);
        if (this.props.project != null) {
            this.state = {
                loadingMap: true
            }
        } else {
            this.state = {
                loadingMap: false
            }
        }
    }

    componentWillMount() {
        //this.props.cleanState();
    }

    handleCommercialProjectSelectionChange(selectedProject) {
        if (selectedProject != null) {
            this.setState({ loadingMap: true });
        }
        this.props.updateCommercialProject(selectedProject);
    }

    handleProductSelectionChange(selectedProduct) {
        this.props.updateProduct(selectedProduct);
    }

    handleCommercialProjectMapSelection(commercialProject) {
        console.log("CommercialProject", commercialProject);
        //this.setState({ loadingMap: true });
        this.props.updateCommercialProject(commercialProject);

    }

    handleParentProjectSelectionChange(parentProject) {
        console.log("parentProject", parentProject);
        if (parentProject != null) {
            this.setState({ loadingMap: true });
            this.props.updateParentProject(parentProject);
            this.props.fetchCommercialProjects(parentProject.value);
            this.props.updateCommercialProject(null);
        }
    }

    render() {
        return (
            <Col className="wizard-step">
                <Row>
                    <Col className="col-12 no-padding no-margin">
                        <Row className="no-padding no-margin">
                            <Col md="4" className="form-group">
                                <ControlLabel><b>Proyecto:</b></ControlLabel>
                                <ProjectSelect
                                    placeholder={"Proyectos..."}
                                    fetchProjects={() => this.props.fetchParentProjects()}
                                    projects={this.props.parentProjects}
                                    selection={this.props.parentProject}
                                    handleChange={(project) => this.handleParentProjectSelectionChange(project)}
                                />
                            </Col>
                            <Col md="4" className="form-group">
                                <ControlLabel><b>Proyecto Comercial:</b></ControlLabel>
                                <ProjectSelect
                                    areCommercials
                                    placeholder={"Proyectos Comerciales..."}
                                    fetchProjects={() => this.props.fetchCommercialProjects()}
                                    projects={this.props.commercialProjects}
                                    selection={this.props.commercialProject}
                                    handleChange={(project) => this.handleCommercialProjectSelectionChange(project)}
                                />
                            </Col>
                            <Col md={4}>
                                {
                                    this.props.product != null &&
                                    <div className="form-group">
                                        <ProductSelectedInfo product={this.props.product} />
                                    </div>
                                }
                            </Col>
                        </Row>
                    </Col>

                    <div className="w-100">
                        <Loader show={true} classes={this.state.loadingMap ? "map-default-height" : "d-none"} />
                        <div className={this.state.loadingMap ? "d-none" : "d-block map-container"}>
                            <ProductSelectMap
                                projectParent={this.props.parentProject}
                                project={this.props.commercialProject}
                                product={this.props.product}
                                handleProjectChange={(project) => this.handleCommercialProjectMapSelection(project)}
                                handleChange={(product) => this.handleProductSelectionChange(product)}
                                handleLoadingMap={(value) => this.setState({ loadingMap: value })}
                            />
                        </div>
                    </div>
                </Row>
            </Col>
        )
    }
}
const mapStateToProps = state => ({
    parentProject: state.projectsview.parentProject,
    commercialProject: state.projectsview.commercialProject,
    product: state.projectsview.product,
    commercialProjects: state.project.items,
    parentProjects: state.project.parents
});
export default connect(
    mapStateToProps,
    {
        updateCommercialProject,
        updateParentProject,
        updateProduct,
        cleanState,
        fetchCommercialProjects,
        fetchParentProjects
    }
)(Projects);



// WEBPACK FOOTER //
// ./src/components/Projects/Projects.jsx